<template>
  <v-dialog
    v-model="dialog"
    persistent
    max-width="350px"
    @keydown.esc="closeDialog"
  >
    <v-card>
      <div class="dialog-container">
        <div>
          <h3 class="popup-title">
            {{ checkDelClose === 'close' ? '회의종료' : '회의삭제' }}
          </h3>
        </div>
        <div
          style="display: flex; justify-content: center; text-align: center; font-size: 14px; padding: 8px;"
        >
          {{
            checkDelClose === 'close'
              ? '진행 중인 회의로 참석 중인 사용자가 있을 수 있습니다. 종료하시겠습니까?'
              : '삭제 시 복구가 불가합니다. 삭제하시겠습니까?'
          }}
        </div>
        <div class="danger-alert" v-if="error">
          {{ error }}
        </div>
        <div class="btnArea">
          <button class="noIconButton" @click="closeDialog()">
            닫기
          </button>

          <button class="btnPrimary" @click="deleteMeetingDialog">
            확인
          </button>
        </div>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
import Util from '@/util';

export default {
  components: {},
  props: [
    'dialog',
    'meetingInfo',
    'meeting',
    'status',
    'closeDialog',
    'checkDelClose',
    'closeDeleteConfirmDialog',
  ],
  data() {
    return {
      loading: true,
      error: null,
      bookmarkTitle: '',
    };
  },
  computed: {
    attendeesString () {
      let attendees_str = '';
      if (this.attendees.length === 1) {
        if (this.attendees[0].name) {
          attendees_str = `${this.attendees[0].name}`;
        } else {
          attendees_str = `${this.attendees[0].email}`;
        }
      } else if (this.attendees.length > 1) {
        if (this.attendees[0].name) {
          attendees_str = `${this.attendees[0].name} 외 ${this.attendees
            .length - 1}명`;
        } else {
          attendees_str = `${this.attendees[0].email} 외 ${this.attendees
            .length - 1}명`;
        }
      }
      return attendees_str;
    },
  },
  watch: {
    dialog: {
      handler(val) {
        this.loading = false;
        this.error = null;
      },
    },
  },
  methods: {
    init () {
      this.error = null;
      this.bookmarkTitle = '';
    },
    close () {
      this.init();
      this.closeDialog();
    },

    async deleteMeetingDialog () {
      this.closeDeleteConfirmDialog();
    },
  },
};
</script>
<style scoped>
.dialog-container {
  width: 350px;
  box-shadow: 1px 1px 18px 0px rgba(50, 50, 50, 0.37);
}
.invite-btn {
  background-color: #604af3;
  color: white;
  width: 100px;
  height: 48px;
  border-radius: 8px;
  margin: 0 5px;
  font-size: 15px;
}
.close-btn {
  width: 100px;
  height: 48px;
  border-radius: 8px;
  background: #f2f2f2;
  color: #1f2e3d;
  margin: 0 5px;
  font-size: 15px;
}

.desc {
  font-size: 14px;
  text-align: center;
  margin: 30px 0 18px 0;
}
.add_name {
  color: #604af3;
  font-weight: 500;
}

.btnArea {
  justify-content: center;
}

.btnArea button:hover {
  opacity: 0.7;
}
</style>



// WEBPACK FOOTER //
// src/components/popup/DeleteConfirmDialog.vue